import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'

import Step from '../../../../../../../features/components/Forms/StepForm/Step'
import ProductSection from './ProductSection'
import SelectOrDeselectAllButton from './SelectOrDeselectAllButton'

import { mediaOrderValidRequestedFilesByProductSelector } from '../../../../../../../modules/selectors/mediaOrdersBookings'

function SelectFilesStep({ formik }) {
  // show only products with uploaded files and with the valid requested files(not floated)
  const mediaOrderRequestedFilesByProduct = useSelector(mediaOrderValidRequestedFilesByProductSelector)

  const productsWithUploadedFiles = useMemo(() => {
    return mediaOrderRequestedFilesByProduct.filter(({ files }) =>
      files.some(({ uploaded_files }) => uploaded_files.length > 0)
    )
  }, [mediaOrderRequestedFilesByProduct])

  return (
    <Step stepTitle="Select files" StepDescriptionRightContent={<SelectOrDeselectAllButton formik={formik} />}>
      {productsWithUploadedFiles.map(({ product, files }) => {
        const allUploadedFilesByProduct = files.flatMap(({ booked_media, uploaded_files }) =>
          uploaded_files.map(file => ({ file, booked_media }))
        )

        return <ProductSection formik={formik} name={product.name} uploadedFiles={allUploadedFilesByProduct} />
      })}
    </Step>
  )
}

SelectFilesStep.propTypes = {
  formik: PropTypes.object
}

export default SelectFilesStep
